export default __webpack_public_path__ + "static/media/star_white.a7a5976f.svg";